import React, { useContext } from 'react'
import { GlobalContext } from '../GlobalContext'

type Props = {
  formFields: { [key: string]: any }
  labelText: string
  handleChange: (key: string, value: any) => void
  fieldName: string,
  errorMessage?: string
  min?: number
  max?: number
  size?: 'big' | 'small',
  center?: boolean
  fullwidth?: boolean
  placeholder?: string
}

function Number({
  formFields,
  labelText,
  handleChange,
  fieldName,
  errorMessage,
  min,
  max,
  size,
  center,
  fullwidth,
  placeholder
}: Props) {

  const classString = `
  bg-white drop-shadow-lg border border-gray-300 text-gray-900 rounded hover:opacity-90-lg focus:ring-blue-500 focus:border-blue-500 block w-full
  ${center ? 'text-center' : 'text-left'}
  ${size === 'big' && 'text-lg px-5 py-3'}
  ${size === 'small' && 'text-xs px-2 py-1'}
  ${size !== 'small' && size !== 'big' && 'text-sm px-3 py-2'}
  `

  return <div className={`${center ? 'text-center' : 'text-left'} ${fullwidth && ` w-full ` } flex flex-col gap-2`}>
    {labelText && <p className={`${center ? 'text-center' : 'text-left'}`}>{labelText}</p>}
    <input
      className={classString}
      type='number'
      name={fieldName}
      placeholder={placeholder}
      id={fieldName}
      min={min}
      max={max}
      value={formFields[fieldName] ? formFields[fieldName] : ''}
      onChange={(e) => handleChange(fieldName, e.target.value)}
      inputMode={/iPhone|iPad|iPod/.test(navigator.userAgent) ? 'text' :`numeric`} // the pattern below means 0 to 9, minus signs and a decimal point
      pattern={"^-?\d*(\.\d+)?$"}
    />
    {formFields[fieldName] && formFields[fieldName]['isValid'] === false && <p className={`${center ? 'text-center' : 'text-left'} text-xs text-red-700`}>
      {errorMessage ? errorMessage : 'Please enter a value'}
    </p>}
  </div>
}
export default Number